import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from "reactstrap";

//Import Breadcrumb

//i18n
import { withTranslation } from "react-i18next";
import { getAllEvents, getAllOrganizer, getBookingByEventId, getForumBySlug } from "api";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import { getAuthUser, getCountryId, getUserRole } from "utils/storage";
import TableContainer from "../../../components/Common/TableContainer";
import moment from "moment";

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import 'jspdf-autotable';
const pagination = true;
const paginationPageSize = 500;
const paginationPageSizeSelector = [200, 500, 1000];
const EventSummary = props => {
    //meta title
    document.title = "Booking List | EventoX";
    const [eventList, setEventList] = useState([])
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [bookingList, setBookingList] = useState([])
    const [reports, setReports] = useState([
        { title: "Total Booking", iconClass: "bx-copy-alt", description: 0 },
        { title: "Total Ticket Purchased", iconClass: "bx-archive-in", description: 0 },
        {
            title: "Total Revenue",
            iconClass: "bx-purchase-tag-alt",
            description: 0,
        },
    ])


    useEffect(() => {
        fetchAll()
    }, [])

    const fetchAll = async () => {
        try {
            const respAllEvent = await getAllEvents();
            const eventOptions = respAllEvent.map((item) => {
                return {
                    value: item.eventId,
                    label: item.eventName,
                    ticketFee: item.ticketFee,
                }
            })
            setEventList(eventOptions);





        } catch (error) {
            console.log(error);
        }
    }

    const fetchBookingByEvent = async (data) => {
        const eventId = data.value;
        const getBookingResp = await getBookingByEventId(eventId)
        console.log("🚀 ~ fetchBookingByEvent ~ getBookingResp", selectedEvent)
        const activeBooking = getBookingResp.filter((item) => item.bookingStatus === 'confirmed');
        const ticketPurchased = activeBooking.filter((item) => item.bookedBy === "0")
        const totalRevenue = ticketPurchased.reduce((acc, item) => acc + item.organizerRevenue, 0)
        const totalDiscount = ticketPurchased.reduce((acc, item) => acc + item.discountAmount, 0)
        const processingFee = ticketPurchased.reduce((acc, item) => acc + item.processingFee, 0)
        const ticketFee=  ticketPurchased.reduce((acc, item) => acc + item.ticketFee, 0)
        const stripeRevenue=ticketPurchased.reduce((acc, item) => acc + item.stripeRevenue, 0)

        const totalFee=parseFloat(processingFee)+parseFloat(ticketFee)+parseFloat(stripeRevenue);
        const totalTicketAmount = parseFloat(totalRevenue) - parseFloat(totalDiscount)+parseFloat(totalFee);
        let summaryData=[
            {
                ticketSold:activeBooking.length,
                ticketSales:totalRevenue,
                discount:totalDiscount,
                processingFee:processingFee.toFixed(2),
                ticketFee:ticketFee.toFixed(2),
                stripeRevenue:stripeRevenue.toFixed(2),
                totalTicketAmount:totalTicketAmount.toFixed(2),

            }
        ]
        setBookingList(summaryData)
       
      

        console.log("🚀 ~ fetchBookingByEvent ~ getBookingResp:", getBookingResp)

    }
    const columns = useMemo(
        () => [

           

            {
                headerName: 'Ticket Sold',
                field: 'ticketSold',
            },
            {
                headerName: 'Total Ticket Amount',
                field: 'ticketSales',
                filter: true

            },
            {
                headerName: 'Discount',
                field: 'discount',
                filter: true

            },
            {
                headerName: 'Processing Fee',
                field: 'processingFee',
                filter: true

            },
            {
                headerName: 'Ticket Fee',
                field: 'ticketFee',
                filter: true

            },
            {
                headerName: 'Stripe Revenue',
                field: 'stripeRevenue',
                filter: true

            },
            {
                headerName: 'Total',
                field: 'totalTicketAmount',
                filter: true

            },
           


        ])
    const sideBar = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
            },
        ],
        defaultToolPanel: 'filters',
    };
 const downloadCSV = () => {
    if (bookingList.length > 0) {
      const csvRows = [];
      const headers = ['Ticket Sold', 'Ticket Sales', 'Discount', 'Processing Fee', 'Ticket Fee', 'Stripe Revenue', 'Total'];
      csvRows.push(headers.join(','));

      for (const row of bookingList) {
        const values = [
          row.ticketSold,
          `$${parseFloat(row.ticketSales).toFixed(2)}`,
          `$${parseFloat(row.discount).toFixed(2)}`,
          `$${parseFloat(row.processingFee).toFixed(2)}`,
          `$${parseFloat(row.ticketFee).toFixed(2)}`,
          `$${parseFloat(row.stripeRevenue).toFixed(2)}`,
          `$${parseFloat(row.totalTicketAmount).toFixed(2)}`
        ];
        csvRows.push(values.join(','));
      }

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('download', 'booking_summary.csv');
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  const downloadPDF = () => {
    if (bookingList.length > 0) {
      import("jspdf").then(({ default: jsPDF }) => {
        import("jspdf-autotable").then(() => {
          const doc = new jsPDF('l', 'mm', 'a4');
          const headers = [['Ticket Sold', 'Ticket Sales', 'Discount', 'Processing Fee', 'Ticket Fee', 'Stripe Revenue', 'Total']];
          const body = bookingList.map(row => [
            row.ticketSold,
            `$${parseFloat(row.ticketSales).toFixed(2)}`,
            `$${parseFloat(row.discount).toFixed(2)}`,
            `$${parseFloat(row.processingFee).toFixed(2)}`,
            `$${parseFloat(row.ticketFee).toFixed(2)}`,
            `$${parseFloat(row.stripeRevenue).toFixed(2)}`,
            `$${parseFloat(row.totalTicketAmount).toFixed(2)}`
          ]);

          doc.autoTable({
            head: headers,
            body: body
          });

          doc.save('booking_summary.pdf');
        });
      });
    }
  };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Event Summery Report")}
                        breadcrumbItem={props.t("Event Summary")}
                    />

                    {/* <Row>
                        <Col xl="12">
                            <Row>
                                {(reports || [])?.map((report, key) => (
                                    <Col md="4" key={"_col_" + key}>
                                        <Card className="mini-stats-wid">
                                            <CardBody>
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                        <p className="text-muted fw-medium">
                                                            {report.title}
                                                        </p>
                                                        <h4 className="mb-0">{report.description}</h4>
                                                    </div>
                                                    <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                                                        <span className="avatar-title rounded-circle bg-primary">
                                                            <i className={"bx " + report.iconClass + " font-size-24"}></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row> */}

                    <Row>
                        <Col lg="12">

                            <Card>
                                <CardBody>
                                   <Row className="mb-3">
                                      <Col xl="5">
                                        <Select
                                          value={selectedEvent}
                                          placeholder="Select Event"
                                           onChange={(data) => {
                                          setSelectedEvent(data);
                                        fetchBookingByEvent(data);  
                                              }}
                                          options={eventList}
                                          width="100%"
                                          className="select2-selection"
                                        />
                                      </Col>
                                    
                                      <Col >
                <div className="text-lg-end mt-3 mt-lg-0">
                  <UncontrolledDropdown>
                    <DropdownToggle color="primary" type="button">
                      <i className="bx bx-download me-2"></i> Export <i className="mdi mdi-chevron-down"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem href="#" onClick={downloadCSV}>Export CSV</DropdownItem>
                      <DropdownItem href="#" onClick={downloadPDF}>Export PDF</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
                                    </Row>
                                            <Row>
                                        <div style={{
                                            height: '500px',
                                            width: '100%'
                                        }} className="ag-theme-quartz">
                                            <AgGridReact
                                                columnDefs={columns}
                                                rowData={bookingList}
                                                sideBar={sideBar}
                                                rowGroupPanelShow="always"
                                                pagination={pagination}
                                                paginationPageSize={paginationPageSize}
                                                paginationPageSizeSelector={paginationPageSizeSelector}
                                            />
                                        </div>

                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};



export default withTranslation()(EventSummary);

